import CustomersProvider from "providers/CustomersProvider"
import ReservationsProvider from "providers/ReservationsProvider"
import TransactionsProvider from "providers/TransactionsProvider"

import CustomersTemplate from "components/templates/CustomersTemplate"

const Customers = () => {
  return (
    <CustomersProvider>
      <ReservationsProvider>
        <TransactionsProvider>
          <CustomersTemplate/> 
        </TransactionsProvider>
      </ReservationsProvider>
    </CustomersProvider>
  )     
}

export default Customers